// extracted by mini-css-extract-plugin
export default {"tabs-headerName":"ULTabsV2_tabs-headerName__-1-t+","tabs-counter":"ULTabsV2_tabs-counter__76lG5"};